import React from 'react'

export const MessengerSvg = () => {
  return (
    <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
      <g clip-path="url(#clip0_14200_13347)">
        <path fill-rule="evenodd" clip-rule="evenodd" d="M11.625 2.85938C6.55504 2.85938 2.625 6.57314 2.625 11.5894C2.625 14.2132 3.70032 16.4805 5.45151 18.0465C5.59852 18.1781 5.68726 18.3624 5.69329 18.5597L5.7423 20.1606C5.75796 20.6713 6.28543 21.0036 6.75271 20.7973L8.53909 20.0087C8.69052 19.9419 8.86021 19.9295 9.01978 19.9734C9.84067 20.1992 10.7144 20.3194 11.625 20.3194C16.695 20.3194 20.625 16.6056 20.625 11.5894C20.625 6.57314 16.695 2.85938 11.625 2.85938Z" fill="#222222" />
        <path fill-rule="evenodd" clip-rule="evenodd" d="M6.22085 14.1423L8.8646 9.94794C9.28514 9.28067 10.1857 9.11453 10.8167 9.58776L12.9194 11.1648C13.1123 11.3095 13.3778 11.3087 13.5699 11.1629L16.4097 9.0077C16.7887 8.72006 17.2835 9.17366 17.0298 9.5762L14.3861 13.7706C13.9655 14.4378 13.065 14.604 12.434 14.1307L10.3312 12.5537C10.1383 12.409 9.87287 12.4098 9.68078 12.5556L6.84095 14.7108C6.46192 14.9984 5.96714 14.5448 6.22085 14.1423Z" fill="white" />
      </g>
      <defs>
        <clipPath id="clip0_14200_13347">
          <rect width="24" height="24" fill="white" />
        </clipPath>
      </defs>
    </svg>
  )
}
